import { i18n } from '@lingui/core';
import type { Messages } from '@lingui/core';

type SupportedLocale = 'en' | 'uk';

const SUPPORTED_LOCALES: SupportedLocale[] = ['en', 'uk'];

export async function initI18n(): Promise<void> {
    const saved = localStorage.getItem('user-lang') ?? navigator.language.split('-')[0];
    const finalLang: SupportedLocale = SUPPORTED_LOCALES.includes(saved as SupportedLocale) 
        ? (saved as SupportedLocale) 
        : 'en';

    const { messages } = await import(`./locales/${finalLang}/messages.mjs`) as { messages: Messages };
    i18n.load(finalLang, messages);
    i18n.activate(finalLang);
}

export type { SupportedLocale };